import { useEffect } from 'react';
import { IonContent, IonPage } from '@ionic/react';
import Landing from '../components/landing';

export const Home = () => {
  useEffect(() => {
    document.title = 'Zimidy';
  }, []);
  return (
    <IonPage>
      <IonContent>
        <Landing />
      </IonContent>
    </IonPage>
  );
};

export default Home;
